var PRECISION = 0.00001; // numbers less than this is considered as 0

export default function isNumberEqual(a, b, precision) {
  if (precision === void 0) {
    precision = PRECISION;
  }

  return Math.abs(a - b) < precision;
}
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-number-equal.js
// module id = 64
// module chunks = 0